export default __webpack_public_path__ + "static/media/SEL751.290fe7ce.png";